import { useState, useEffect, useCallback, useMemo } from "react";
import FilterMenu from "../../../components/FilterMenu";
import { ChartAreaLoader } from "../../../components/Loading";
import {
  ChartDataParams,
  FormatChartData,
} from "../../../components/recharts/functions";
import { ReMixChart } from "../../../components/recharts/ReMixCharts";
import { SearchBox } from "../../../components/Search";
import { RajasthanGenData } from "../../../models/rajasthan";
import {
  getRajasthanGenerationData,
  getRajasthanIsgsIntervalData,
  getRajasthanOutageData,
  getRajReData,
} from "../Utility/RestApi";
import {
  formatDateForAPI,
  getLast7DaysDateRange,
  R_AREA_CHART_TYPES,
  R_CHART_TYPES,
} from "../const";
import { handleUnitChange, RAJ_UNITS } from "../const_raj";
import { getMonthFromDate, months } from "../../../extensions/date";
import { titleCase } from "../../../extensions/extension";
import {
  getRandomColor,
  stringToConsistentColor,
} from "../../../extensions/string";
import { renderHourTick } from "../../../components/recharts/components";
import Tooltip from "../../../components/tooltip";
import {
  calculateTimePeriods,
  DEFAULT_FINANCIAL_YEARS,
  DEFAULT_QUARTERS,
  DEFAULT_YEARS,
  FilteredOutEntity,
} from "./Data";
import LegendSummaryTable, {
  ChartTable,
  downloadChartTableCSV,
  downloadSummaryCSV,
} from "../../../components/table/SummaryTable";
import { useDispatch, useSelector } from "react-redux";
import NewFilterContainer from "../../../components/NewFilterContainer ";
import MainPageContainer from "../../../components/MainPageContainer";
import SecondaryHeader from "../Demand/SecondaryHeader";
import {
  updateDateRangeOptions,
  updateDefaultDates,
  updateShowDateRnage,
} from "../../../store/state/DefaultDatesSetter";
import { BrushStart } from "../../../models/chart_model";
import { AddDatesWithFileName } from "../../../helpers/helper";
import BlockRangeSelector from "../../../components/BlockRangeSelector/BlockRangeSelector";
import { useLegendFilter } from "../../../hooks/useLegendFilter";

const CHART_TYPES = [R_CHART_TYPES[0], R_CHART_TYPES[2], R_AREA_CHART_TYPES];

const GENERATION_TYPE = ["Interstate", "Intrastate"];
export const INTERVAL = [
  {
    name: "Time Slot",
    firstKey: "slot",
    secondKey: "date",
    label: "Time Slot",
    key: "time",
    values: ["slot", "dateIndex", "dateIndex_num", "date"],
    isTime: true,
  },
  {
    name: "Date",
    firstKey: "date",
    secondKey: undefined,
    label: "Date",
    key: "date",
    values: ["dateIndex", "dateIndex_num", "date"],
    isTime: false,
  },
  {
    name: "Month",
    firstKey: "month",
    secondKey: undefined,
    label: "Month",
    key: "month",
    values: ["month"],
    isTime: false,
  },
  {
    name: "Quarter",
    firstKey: "quarter",
    secondKey: undefined,
    label: "Quarter",
    key: "quarter",
    values: ["quarter"],
    isTime: false,
  },
  {
    name: "Year",
    firstKey: "year",
    secondKey: undefined,
    label: "Year",
    key: "year",
    values: ["year"],
    isTime: false,
  },
  {
    name: "Financial Year",
    firstKey: "financialYear",
    secondKey: undefined,
    label: "Financial Year",
    key: "financialYear",
    values: ["financialYear"],
    isTime: false,
  },
];

const variables = [
  {
    value: "onBarDS",
    label: "Generated",
  },
  {
    value: "onBarDc",
    label: "Capacity (Declared)",
  },
  {
    value: "backdown",
    label: "Backdown",
  },
  {
    value: "outage",
    label: "Outage",
  },
];

export function   ByPowerStation() {
  const dispatch = useDispatch();
  const activeTab = useSelector((state: any) => state.switchTabs.activeTab);
  const DefaultDates = useSelector(
    (state: any) => state.defaultDatesSetter.defaultDates
  );
  console.log(DefaultDates);
  const dataTab = useSelector((state: any) => state.viewMode.activeView);
  const [data, setData] = useState<RajasthanGenData[]>([]);
  const [chartKeys, setChartKeys] = useState<any[]>([]);
  const [selectedStation, setSelectedStation] = useState<any[]>([]);
  const [states, setStates] = useState<string[]>([]);
  const [selectedState, setSelectedState] = useState<string[]>([]);
  const [selectedKey, setselectedKey] = useState(INTERVAL[0]);
  const [selectedGenerationType, setSelectedGenerationType] =
    useState(GENERATION_TYPE);
  const [selectedVariable, setSelectedVariable] = useState([variables[0]]);
  const [selectedUnit, setSelectedUnit] = useState(RAJ_UNITS[0]);
  const [uniqueDate, setUniqueDate] = useState<any[]>([]);
  const [uniqueStations, setUniqueStations] = useState<string[]>([]);
  const [uniqueBlock, setUniqueBlock] = useState<any[]>([]);
  const [selectedBlock, setSelectedBlock] = useState<any[]>([]);
  const [chartData, setChartData] = useState<any[]>([]);
  const [selectedChartType, setSelectedChartType] = useState(CHART_TYPES[1]);
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState<any[]>([]);

  const _handlefetchData = useCallback(async () => {
    if (DefaultDates[activeTab].defaultRangeDate === undefined) {
      return;
    }
    setLoading(true);
    let bb;
    const dates = DefaultDates[activeTab].defaultRangeDate;

    if (
      selectedKey.key === "year" ||
      selectedKey.key === "financialYear" ||
      selectedKey.key === "quarter"
    ) {
      const [startDate, endDate] = dates.value.split(",");
      bb = [
        {
          value: `${startDate},${endDate}`,
          label: `${startDate} - ${endDate}`,
        },
      ];
    } else {
      const startDateStr =
        dates.startDate instanceof Date
          ? formatDateForAPI(dates.startDate)
          : dates.startDate;

      const endDateStr =
        dates.endDate instanceof Date
          ? formatDateForAPI(dates.endDate)
          : dates.endDate;

      bb = [
        {
          value: `${startDateStr},${endDateStr}`,
          label: `${startDateStr} - ${endDateStr}`,
        },
      ];
    }

    try {
      const results = await Promise.all(
        bb.map(async (date) => {
          const [startDate, endDate] = date.value.split(",");
          const [outageData, intraData, reGenData, isgsData] =
            await Promise.all([
              getRajasthanOutageData(
                startDate,
                endDate,
                selectedKey.key === "financialYear"
                  ? "fiscal-year"
                  : selectedKey.key
              ).then((data) =>
                data.map(
                  (item: {
                    outage_mw: number;
                    outage_date: any;
                    outage_time: any;
                    station_name: string;
                    year: string;
                    quarter: string;
                    fiscal_year: string;
                    month: any;
                  }) => ({
                    ...item,
                    dates: date.value,
                    outage_mw: item.outage_mw || 0,
                    outage_mwh: item.outage_mw / 4 || 0,
                    date: item.outage_date,
                    sector: "Intrastate",
                    slot: item.outage_time,
                    station: item.station_name + " Intrastate",
                    state: "Rajasthan RE",
                    onBarDc_mw: 0,
                    onBarDc_mwh: 0,
                    backdown_mw: 0,
                    backdown_mwh: 0,
                    year: item.year ?? undefined,
                    quarter: item.quarter
                      ? `Q${item.quarter + "-" + item.year}`
                      : undefined,
                    financialYear: item.fiscal_year
                      ? `FY${parseInt(item.fiscal_year)}-${(
                          parseInt(item.fiscal_year + 1) % 100
                        )
                          .toString()
                          .padStart(2, "0")}`
                      : undefined,
                    month: item.month
                      ? months[Number(item.month) - 1].slice(0, 3) +
                        " " +
                        item.year
                      : undefined,
                  })
                )
              ),

              getRajasthanGenerationData(startDate, endDate).then((data) =>
                data
                  .map((item) => {
                    const timePeriods = calculateTimePeriods(item.date);
                    return {
                      ...item,
                      outage_mw: 0,
                      outage_mwh: 0,
                      sector: "Intrastate",
                      source: titleCase(titleCase(item.source)),
                      station: item.station + " Intrastate",
                      dates: date.value,
                      year: timePeriods.year,
                      quarter: timePeriods.quarter,
                      financialYear: timePeriods.financialYear,
                      month:
                        getMonthFromDate(item.date) + " " + timePeriods.year,
                    };
                  })
                  .filter(
                    (item) =>
                      item.backdown_mw !== 0 ||
                      item.onBarDS_mw !== 0 ||
                      item.onBarDc_mw !== 0
                  )
              ),

              getRajReData({ startDate, endDate }).then((data) =>
                data
                  .map((item) => {
                    const timePeriods = calculateTimePeriods(item.date);
                    return {
                      ...item,
                      source: titleCase(item.energy_type),
                      outage_mw: 0,
                      outage_mwh: 0,
                      onBarDS_mw: item.value_mw,
                      onBarDS_mwh: item.value_mw / 4,
                      onBarDc_mw: 0,
                      onBarDc_mwh: 0,
                      backdown_mw: 0,
                      backdown_mwh: 0,
                      station: `${titleCase(item.energy_type)} RE ${item.area}`,
                      sector:
                        item.area === "InterState"
                          ? "Interstate"
                          : "Intrastate",
                      slot: item.time_block,
                      state: "Rajasthan RE",
                      dates: date.value,
                      year: timePeriods.year,
                      quarter: timePeriods.quarter,
                      financialYear: timePeriods.financialYear,
                      month:
                        getMonthFromDate(item.date) + " " + timePeriods.year,
                    };
                  })
                  .filter((item) => item.area === "IntraState")
              ),

              getRajasthanIsgsIntervalData({
                startDate,
                endDate,
                interval:
                  selectedKey.key === "financialYear"
                    ? "fiscal-year"
                    : selectedKey.key,
              }).then((data) =>
                data
                  .map((item) => ({
                    ...item,
                    onBarDS_mw: item.value_mw,
                    outage_mw: 0,
                    outage_mwh: 0,
                    source: titleCase(item.from_gen__generation_source),
                    onBarDS_mwh:
                      selectedKey.label === "Year" ||
                      selectedKey.label === "Financial Year" ||
                      selectedKey.label === "Quarter"
                        ? item.value_mw
                        : item.value_mw / 4,
                    onBarDc_mw: 0,
                    onBarDc_mwh: 0,
                    backdown_mw: 0,
                    backdown_mwh: 0,
                    station: `${item.from_utility__name} Interstate`,
                    sector: "Interstate",
                    dates: date.value,
                    year: item.year ?? undefined,
                    quarter: item.quarter
                      ? `Q${item.quarter}-${item.year}`
                      : undefined,
                    financialYear: item.fiscal_year
                      ? `FY${parseInt(item.fiscal_year)}-${(
                          parseInt(item.fiscal_year + 1) % 100
                        )
                          .toString()
                          .padStart(2, "0")}`
                      : undefined,
                    month: item.month
                      ? months[Number(item.month) - 1].slice(0, 3) +
                        " " +
                        item.year
                      : undefined,
                  }))
                  .filter(
                    (item) =>
                      item.backdown_mw !== 0 ||
                      item.onBarDS_mw !== 0 ||
                      item.onBarDc_mw !== 0
                  )
              ),
            ]);
          return [...reGenData, ...intraData, ...isgsData, ...outageData];
        })
      );
      const newData = results.flat();
      const processedData = newData.map((item) => ({
        ...item,
        dates:
          uniqueDate.find((d) => d.value === item.dates)?.label ?? item.dates,
      }));
      setData(processedData);
      const uniqueStations = Array.from(
        new Set(newData.map((item) => item.station))
      );
      setUniqueStations(uniqueStations);
      setStates(Array.from(new Set(newData.map((item) => item.state))));
      setUniqueBlock(
        Array.from(new Set(processedData.map((item) => item.slot)))
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }, [DefaultDates, activeTab, selectedKey.key, selectedKey.label, uniqueDate]);

  useEffect(() => {
    let filteredData = data;

    if (selectedBlock.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedBlock.map((item) => item.value).includes(item.slot)
      );
    }

    if (selectedGenerationType.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedGenerationType.includes(item.sector!)
      );
    }
    if (selectedState.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedState.includes(item.state)
      );
    }
    setUniqueStations(
      Array.from(new Set(filteredData.map((item) => item.station)))
    );
    if (selectedStation.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedStation.map((i) => i.label).includes(item.station)
      );
    }

    const slotCapactiyDivison = 1;
    const dayCapactiyDivison = 96;
    const monthCapactiyDivison = 96 * 30;
    const uniqueTimeSlotAndDate = Array.from(
      new Set(data.map((item) => item.date + " " + item.slot))
    );
    if (
      selectedKey.firstKey === "station" ||
      selectedKey.firstKey === "sector" ||
      selectedKey.firstKey === "state" ||
      selectedKey.firstKey === "source"
    ) {
      filteredData = filteredData.map((item) => {
        return {
          ...item,
          onBarDc_mwh: item.onBarDc_mw! / uniqueTimeSlotAndDate.length,
          onBarDc_mw: item.onBarDc_mw! / uniqueTimeSlotAndDate.length,
        };
      });
    } else if (selectedKey.firstKey == "date") {
      filteredData = filteredData.map((item) => {
        return {
          ...item,
          onBarDc_mwh: item.onBarDc_mw! / dayCapactiyDivison,
          onBarDc_mw: item.onBarDc_mw! / dayCapactiyDivison,
        };
      });
    } else if (selectedKey.firstKey == "month") {
      filteredData = filteredData.map((item) => {
        return {
          ...item,
          onBarDc_mwh: item.onBarDc_mw! / monthCapactiyDivison,
          onBarDc_mw: item.onBarDc_mw! / monthCapactiyDivison,
        };
      });
    }
    const selectedFilterStations = selectedStation.filter((item) =>
      FilteredOutEntity.includes(item.label)
    );

    if (selectedFilterStations.length === 0) {
      filteredData = filteredData.filter(
        (item) => !FilteredOutEntity.includes(item.station)
      );
    }

    const par: ChartDataParams = {
      keys: selectedKey.secondKey
        ? [selectedKey.firstKey, selectedKey.secondKey]
        : [selectedKey.firstKey],
      tableKeys: ["date", "slot"],
      groupBy: ["station"],
      volumeKey: "",
      aggregationKeys: [
        "onBarDc_mw",
        "backdown_mw",
        "outage_mw",
        "offBarWarm_mw",
        "onBarDS_mwh",
        "onBarDc_mwh",
        "backdown_mwh",
        "offBarWarm_mwh",
        "outage_mwh",
      ],
      sortby: selectedKey.firstKey == "station" ? ["_onBarDS_mw"] : undefined,
      reverseSort: ["date", "slot"],
      priceKey: "",
      averageDuplicationKeys: ["date", "slot"],
      averageKeys: [
        "onBarDS_mw",
        "onBarDc_mw",
        "backdown_mw",
        "offBarWarm_mw",
        "outage_mw",
      ],
      data: filteredData,
    };
    const cData = FormatChartData(par);
    setTableData(cData.tableData || []);
    setChartKeys(cData.keys);
    setChartData(cData.data);
  }, [
    data,
    selectedBlock,
    selectedGenerationType,
    selectedState,
    DefaultDates,
    activeTab,
    selectedKey.firstKey,
    selectedKey.secondKey,
    selectedStation,
  ]);

  useEffect(() => {
    _handlefetchData();
  }, [_handlefetchData]);

  const handlexDataKey = useCallback(() => {
    if (selectedKey.name === "Time Slot") {
      if (selectedBlock.length > 0) {
        return "slot";
      }
      return "slot";
    } else {
      return selectedKey.firstKey;
    }
  }, [selectedBlock.length, selectedKey.firstKey, selectedKey.name]);

  const xDataKey = useMemo(() => handlexDataKey(), [handlexDataKey]);

  function summaryExtraKeys() {
    if (selectedKey.isTime) {
      return ["slot", "date"];
    } else if (selectedKey.key === "date") {
      return ["date"];
    } else {
      return selectedKey.values;
    }
  }

  const summaryExtraLabels = selectedKey.values.map((value) =>
    value === "date" ? "Date" : value
  );

  const allLegends = useMemo(
    () => getLegends(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [chartKeys, selectedVariable, selectedUnit, selectedChartType]
  );

  const { visibleLegends, handleLegendSelect, selectedLegends: selectedLegendKeys } =
    useLegendFilter(allLegends as any);

  const tablePar = {
    legends: visibleLegends,
    data: chartData,
    tableData: tableData,
    itemsPerPage: 96,
    unit: selectedUnit,
    extraKeys: summaryExtraKeys(),
    extraLabels: summaryExtraLabels,
    filename: AddDatesWithFileName({
      fileName: "Generation By Power Station",
      dates: DefaultDates[activeTab].defaultRangeDate,
    }),
  };

  function handleDefaultDates(index: number) {
    setData([]);
    if (INTERVAL[index].key === "year") {
      dispatch(updateShowDateRnage({ activeTab, state: true }));
      dispatch(updateDateRangeOptions({ activeTab, dates: DEFAULT_YEARS }));
      dispatch(updateDefaultDates({ activeTab, dates: DEFAULT_YEARS[0] }));
      return;
    }
    if (INTERVAL[index].key === "quarter") {
      dispatch(updateShowDateRnage({ activeTab, state: true }));
      dispatch(updateDateRangeOptions({ activeTab, dates: DEFAULT_QUARTERS }));
      dispatch(updateDefaultDates({ activeTab, dates: DEFAULT_QUARTERS[0] }));
      return;
    }
    if (INTERVAL[index].key === "financialYear") {
      dispatch(updateShowDateRnage({ activeTab, state: true }));
      dispatch(
        updateDateRangeOptions({ activeTab, dates: DEFAULT_FINANCIAL_YEARS })
      );
      dispatch(
        updateDefaultDates({
          activeTab,
          dates: DEFAULT_FINANCIAL_YEARS[0],
        })
      );
      return;
    }
    if (INTERVAL[index].key === "month") {
      dispatch(updateShowDateRnage({ activeTab, state: false }));
      dispatch(
        updateDefaultDates({ activeTab, dates: getLast7DaysDateRange() })
      );
      return;
    }
    if (INTERVAL[index].key === "date" || INTERVAL[index].key === "time") {
      dispatch(updateShowDateRnage({ activeTab, state: false }));
      dispatch(
        updateDefaultDates({
          activeTab,
          dates: getLast7DaysDateRange(), 
        })
      );
      return;
    }
  }

  useEffect(() => {
    if (!DefaultDates[activeTab]?.defaultRangeDate) {
      dispatch(updateShowDateRnage({ activeTab, state: false }));
      dispatch(
        updateDefaultDates({
          activeTab,
          dates: getLast7DaysDateRange(),
        })
      );
    }
  }, [activeTab, dispatch]);

  return (
    <div className="gas-page-container">
      <NewFilterContainer>
        <div className="side-filters-container text-nowrap">
          <FilterMenu
            title="Interval"
            items={INTERVAL.map((item) => item.name)}
            selectedItems={[selectedKey.name]}
            onSelect={(item, index) => {
              setselectedKey(INTERVAL[index]);
              handleDefaultDates(index);
            }}
          />

          <FilterMenu
            title="Unit"
            items={RAJ_UNITS.map((item) => item)}
            selectedItems={[selectedUnit]}
            onSelect={(item, index) => {
              handleUnitChange(item, selectedKey, setSelectedUnit);
            }}
          />

          <FilterMenu
            title="Variable"
            items={variables.map((item) => item.label)}
            selectedItems={selectedVariable.map((item) => item.label)}
            onSelect={(item, index) => {
              // Check if the item is already selected
              const isSelected = selectedVariable.some((v) => v.label === item);

              if (isSelected) {
                // If selected, remove it (unless it's the last one)
                if (selectedVariable.length > 1) {
                  setSelectedVariable(
                    selectedVariable.filter((v) => v.label !== item)
                  );
                }
              } else {
                // If not selected, add it
                setSelectedVariable([...selectedVariable, variables[index]]);
              }
            }}
          />
          <FilterMenu
            title="Area"
            items={GENERATION_TYPE}
            setSelectedItems={setSelectedGenerationType}
            selectedItems={selectedGenerationType}
          />

          <FilterMenu
            title="Chart Type"
            items={CHART_TYPES.map((item) => item.label)}
            selectedItems={[selectedChartType.label]}
            onSelect={(item, index) => {
              setSelectedChartType(CHART_TYPES[index]);
            }}
          />
          <FilterMenu
            title="State"
            items={states}
            selectedItems={selectedState}
            setSelectedItems={setSelectedState}
          />
        </div>
      </NewFilterContainer>

      <MainPageContainer>
        <SecondaryHeader />
        <div className="gas-chart-container">
          {loading ? <ChartAreaLoader title="Loading By Power Station" subtitle="Fetching station-wise generation & scheduling data…" /> : (<>
          <div className="gas-heading">
            <h2 className="chartHeading w-80">By Power Station</h2>
            <div className="flex gap-x-2 w-full justify-end">
              {(selectedKey.key === "time" ||
                selectedKey.key === "date" ||
                (selectedKey.key === "month" &&
                  !selectedVariable.some((v) => v.value === "outage"))) && (
                <BlockRangeSelector
                  blocks={Array.from({ length: 96 }, (_, i) => i + 1)}
                  placeholder="Search Block"
                  selectedOptions={selectedBlock.map((item) => item.value)}
                  setSelectedOptions={setSelectedBlock}
                />
              )}

              <SearchBox
                options={uniqueStations
                  .filter((item) => !item.includes("RE IntraState"))
                  .map((item) => {
                    return { value: item, label: item };
                  })}
                isMany={true}
                placeholder="Search Sources"
                selectedOptions={selectedStation}
                onChange={setSelectedStation}
              />
              <button
                onClick={() => {
                  dataTab.label === "Chart" && downloadChartTableCSV(tablePar);
                  //

                  dataTab.label === "Summary" && downloadSummaryCSV(tablePar);

                  dataTab.label === "Table" && downloadChartTableCSV(tablePar);
                }}
                className="downloadButton"
              >
                Download Data
              </button>
            </div>
          </div>

          {dataTab.label === "Chart" && (
            <>
              <ReMixChart
                data={chartData}
                xAxisAngle={selectedKey.isTime ? 0 : 10}
                xAxisTickMargin={10}
                showBrush={chartData.length > 96 ? true : undefined}
                brushStart={BrushStart.Start}
                isTimeSlot={selectedKey.firstKey === "slot"}
                onlyTitle={true}
                barCategoryGap={20}
                unit={selectedUnit}
                yAxisLabel={selectedUnit}
                legends={allLegends}
                onLegendSelect={handleLegendSelect}
                defaultSelectedLegends={selectedLegendKeys}
                xDataKey={xDataKey}
                xTick={
                  selectedKey.secondKey !== undefined &&
                  selectedBlock.length == 0
                    ? (value: any, index: any) => {
                        return renderHourTick(value, 10);
                      }
                    : undefined
                }
                secondXDataKey={
                  //   "date"
                  selectedKey.secondKey
                }
              />
            </>
          )}

          {dataTab.label === "Summary" && <LegendSummaryTable {...tablePar} />}
          {dataTab.label === "Table" && <ChartTable {...tablePar} />}
          </>)}
        </div>
        <div className="gna-footer-container">
          <div className="grid grid-cols-3 justify-between gap-5 ">
            <Tooltip
              text="1.	Generation by Individual stations can be seen
"
              note={
                <p>
                  Intrastate generation : ELTRIX Backdown Reports, Intrastate RE
                  generation : NREB Grid Curves Interstate, generation : Net
                  schedule report breakup ISGS (WBES), Interstate RE generation:
                  Net schedule report breakup OA REMC (WBES)
                </p>
              }
            >
              <p className="gna-footer-text">Source</p>
            </Tooltip>
            <p className="gna-footer-text col-span-1 text-center">
              Powered by <strong>GNA Energy</strong>
            </p>
            <strong className="gna-footer-text col-span-1 text-end">
              Beta Version
            </strong>
          </div>
        </div>
      </MainPageContainer>
    </div>
  );

  function getLegends() {
    // Flatten the array of legends for all selected variables
    return selectedVariable
      .flatMap((variable) => {
        return getSelectedUnits().map((item) => {
          return {
            dataKey: `${item.value}_${
              variable.value
            }_${selectedUnit.toLowerCase()}`,
            name: `${item.label} ${variable.label}`,
            // legendColor: undefined,
            // stroke: stringToConsistentColor(`${item.value}_${variable.value}`),
            type: selectedChartType.value,
            stackId: selectedChartType.stackId,
          };
        });
      })
      .filter(Boolean);
  }

  function getSelectedUnits(): {
    value: string;
    label: string;
    color: string;
    type: string;
  }[] {
    let keys = chartKeys.map((item) => {
      return {
        ...item,
        value: item,
        label: item,
        color: getRandomColor(item),
        type: "onLoad",
      };
    });

    return keys;
  }
}
